document.querySelectorAll('.htesti-wrap').forEach(function(root){
  var lightbox = root.querySelector('[data-lightbox]');
  var lbImg = root.querySelector('[data-lightbox-img]');
  var lbClose = root.querySelector('[data-lightbox-close]');
  var lbPrev = root.querySelector('[data-lightbox-prev]');
  var lbNext = root.querySelector('[data-lightbox-next]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-trigger]'));
  var lbIndex = -1;

  function showLightboxImage(i){
    if(!tiles.length) return;
    lbIndex = (i + tiles.length) % tiles.length;
    var t = tiles[lbIndex];
    lbImg.classList.remove('is-loaded');
    lbImg.src = t.getAttribute('data-full');
    if(lbImg.complete) lbImg.classList.add('is-loaded');
  }
  lbImg.addEventListener('load', function(){ lbImg.classList.add('is-loaded'); });

  function openLightbox(i){
    showLightboxImage(i);
    lightbox.classList.add('is-open');
    document.body.style.overflow='hidden';
  }
  function closeLightbox(){
    lightbox.classList.remove('is-open');
    document.body.style.overflow='';
    lbImg.src='';
  }
  tiles.forEach(function(t, i){
    t.addEventListener('click', function(){ openLightbox(i); });
  });
  if(lbClose) lbClose.addEventListener('click', closeLightbox);
  if(lightbox) lightbox.addEventListener('click', function(e){ if(e.target === lightbox) closeLightbox(); });
  if(lbPrev) lbPrev.addEventListener('click', function(e){ e.stopPropagation(); showLightboxImage(lbIndex - 1); });
  if(lbNext) lbNext.addEventListener('click', function(e){ e.stopPropagation(); showLightboxImage(lbIndex + 1); });
  document.addEventListener('keydown', function(e){
    if(!lightbox.classList.contains('is-open')) return;
    if(e.key === 'Escape') closeLightbox();
    if(e.key === 'ArrowLeft') showLightboxImage(lbIndex - 1);
    if(e.key === 'ArrowRight') showLightboxImage(lbIndex + 1);
  });
});